import { render, staticRenderFns } from "./officePreview.vue?vue&type=template&id=38ad640e&scoped=true"
import script from "./officePreview.vue?vue&type=script&lang=js"
export * from "./officePreview.vue?vue&type=script&lang=js"
import style0 from "./officePreview.vue?vue&type=style&index=0&id=38ad640e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ad640e",
  null
  
)

export default component.exports